import { render, staticRenderFns } from "./CardInvitationHistory.vue?vue&type=template&id=66cba4ad&scoped=true&"
import script from "./CardInvitationHistory.vue?vue&type=script&lang=js&"
export * from "./CardInvitationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cba4ad",
  null
  
)

export default component.exports